import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { Grid, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import { coverPresenceBatchModelInitial } from '../../../../Models/CoverPresenceBatchModel';
import { CoverPresenceModel, coverPresenceModelInitial } from '../../../../Models/CoverPresenceModel';
import { BasicConfirmDialog } from '../../../../shared/components/BasicConfirmDialog';
import { theme } from '../../../../theme';
import { HomeContext } from '../../../Home/HomeContext';
import { RevisionContext } from '../RevisionContext';
import CoverPresenceService from '../../../../Services/CoverPresenceService';
import ClassificationService from '../../../../Services/ClassificationService';
import { BatchCorrectionContext } from '../BatchCorrectionContext';

export function CoverPresenceBatchCorrection() {

    const revisionContext = React.useContext(RevisionContext);
    const homeContext = React.useContext(HomeContext);
    const batchCorrectionContext = React.useContext(BatchCorrectionContext);

    const [coverPresenceSelected, setCoverPresenceSelected] = React.useState<CoverPresenceModel | null>(null);
    const [coverPresenceList, setCoverPresenceList] = React.useState<CoverPresenceModel[]>([]);

    const [coverPresenceNotDefinedError, setCoverPresenceNotDefinedError] = React.useState(false);

    React.useEffect(() => {
        if (revisionContext.coverPresenceBatchOpenDialog) {
            homeContext.setOpenLoadingDialog(true);
            CoverPresenceService.getCoverPresenceByMediaId(revisionContext.mediaId)
                .then((res: AxiosResponse) => { setCoverPresenceList(res.data); })
                .catch((error: AxiosError) => { homeContext.showError('', error); })
                .finally(() => { homeContext.setOpenLoadingDialog(false); });
        }
    }, [revisionContext.coverPresenceBatchOpenDialog]);

    const hasError = () => {

        const errorCoverPresence: boolean = (coverPresenceList && coverPresenceList.length > 0 && !coverPresenceSelected);

        setCoverPresenceNotDefinedError(errorCoverPresence);

        return (errorCoverPresence);
    };

    const updateCoverPresence = () => {
        if (!hasError()) {
            homeContext.setOpenLoadingDialog(true);

            const coverPresenceData = { ...coverPresenceBatchModelInitial };
            coverPresenceData.coverPresence = coverPresenceSelected ? coverPresenceSelected : coverPresenceModelInitial;
            coverPresenceData.classificationsId = revisionContext.ids;

            ClassificationService.updateCoverPresenceBatch(coverPresenceData)
                .then(() => {
                    clearModalCoverPresence();
                    homeContext.setOpenLoadingDialog(false);
                    homeContext.showSuccess(`As alterações foram realizadas para todas as ${revisionContext.ids.length} classificações selecionadas com sucesso!`);
                    batchCorrectionContext.setCallSearch(true);
                })
                .catch((error: AxiosError) => {
                    homeContext.showError(' Ops... Ocorreu um erro e não foi possível salvar a alteração de presença na capa. '
                        + 'Por favor, tente novamente dentro de alguns instantes. <br/>', error);
                    homeContext.setOpenLoadingDialog(false);
                });
        }
    };

    const clearModalCoverPresence = () => {
        revisionContext.setCoverPresenceBatchOpenDialog(false);
        setCoverPresenceList([]);
        setCoverPresenceSelected(null);
        setCoverPresenceNotDefinedError(false);
    };

    const getCoverPresence = () => (
        <>
            <Grid item xs={12} sm={12}>
                <Autocomplete
                    id="cover-presence"
                    value={coverPresenceSelected}
                    options={coverPresenceList}
                    onChange={(_, value: CoverPresenceModel | null) => setCoverPresenceSelected(value)}
                    getOptionLabel={(option) => option.name}
                    fullWidth
                    noOptionsText="Sem resultados"
                    loadingText="Carregando..."
                    renderInput={(params) =>
                        <TextField {...params}
                            label="Presença na Capa"
                            variant="outlined"
                            error={coverPresenceNotDefinedError && !coverPresenceSelected}
                            helperText={coverPresenceNotDefinedError && !coverPresenceSelected ? 'Campo obrigatório' : ''} />
                    } />
            </Grid>
        </>
    );

    return (
        <BasicConfirmDialog
            title={'Alteração de Presença na Capa'}
            description={'Selecione o tipo de presença na capa que deseja para as classificações selecionadas.'}
            handleFirstButton={() => clearModalCoverPresence()}
            handleSecondButton={() => updateCoverPresence()}
            textFirstButton='DESCARTAR'
            textSecondButton='SALVAR'
            open={revisionContext.coverPresenceBatchOpenDialog}
            children={getCoverPresence()}
            cssProperties={{
                minWidth: '600px',
                maxWidth: '600px',
                padding: '1rem',
                colorFirstButton: theme.palette.primary.main,
                justifyButtons: 'flex-end',
                titleVariant: 'h4',
                descriptionVariant: 'body1'
            }} />
    );
}